import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchRooms, addRooms, addRoomAsync, updateRoom, deleteRoom, deleteRoomAsync } from 'store/actions/index';
import WithError from 'HOC/Error/WithError';
import { axiosCms } from 'Axios.js';
import styles from './RoomsPage.module.css';

import Spinner from 'components/UI/Spinner/Spinner';
import * as Page from 'HOC/Layout/PageContainer';

import RoomsList from 'components/Rooms/RoomsList';

const { Container, Title } = Page;

class RoomsPage extends Component {
  state = {
    showCreateModal: false,
  };

  componentDidMount() {
    const { fetchRooms } = this.props;
    fetchRooms();
  }

  onDeleteHandler = value => {
    // if the incoming value for delete is null,
    // just remove from application store
    // else remove from server
    if (value.name === null && value.id === 0 && value.created_at === 0 && value.updated_at === 0)
      return this.props.deleteRoom();
    else return this.props.deleteRoomAsync(value);
  };

  onUpdateHandler = value => {
    // if incoming id for update is 0
    // create new room in server
    // else update room from server
    if (value.id === 0 && value.created_at === 0 && value.updated_at === 0) return this.props.addRoomAsync(value);
    else return this.props.updateRoom(value);
  };

  renderSpinner = () => <Spinner />;

  renderContainer = () => {
    const { isLoading, items, addRooms } = this.props;
    return (
      <Container type="2x3">
        <Title title="Rooms" button={true} onClick={addRooms} />
        <div className={styles.Main}>
          <RoomsList
            rooms={items}
            isLoading={isLoading}
            onDelete={this.onDeleteHandler}
            onUpdate={this.onUpdateHandler}
          />
        </div>
      </Container>
    );
  };

  render() {
    return this.renderContainer();
  }
}

const mapStateToProps = state => {
  const { items } = state.room;
  const isLoading = state.room.loading || state.auth.loading;
  return {
    isLoading,
    items,
  };
};

const mapDispatchToProps = {
  fetchRooms,
  addRooms,
  addRoomAsync,
  updateRoom,
  deleteRoom,
  deleteRoomAsync,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithError(RoomsPage, axiosCms));



// WEBPACK FOOTER //
// ./src/containers/Rooms/RoomsPage.js